import { Component, HostListener, ViewChild, ElementRef } from '@angular/core';
import { ResizeService } from './shared/common/resize.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent {
  title = 'NetSoft App';

  @ViewChild('resizable', { static: false }) resizable: ElementRef;

  constructor(
    private readonly _resizeService: ResizeService
  ) {

  }
  /* public ngAfterViewInit() {
    this.context = this.gameCanvas.nativeElement.getContext("2d");
  } */
  /*   getAnimationData(outlet: RouterOutlet) {
      return outlet && outlet.activatedRouteData && outlet.activatedRouteData['animation'];
    }
   */

  @HostListener('window:resize', ['$event'])
  onWindowResize(event) {
    console.log("onWindowResize : " + event.target.type);
    let szObj = { width: this.resizable.nativeElement.offsetWidth, height: this.resizable.nativeElement.offsetHeight };
    this._resizeService.UpdateCast(szObj);
  }
}


/*
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Observer } from 'rxjs/Observer';
import { Message } from '../model/message';
import { Event } from '../model/event';

import * as socketIo from 'socket.io-client';

const SERVER_URL = 'http://localhost:8080';

@Injectable()
export class SocketService {
  private socket;

  public initSocket(): void {
      this.socket = socketIo(SERVER_URL);
  }

  public send(message: Message): void {
      this.socket.emit('message', message);
  }

  public onMessage(): Observable<Message> {
      return new Observable<Message>(observer => {
          this.socket.on('message', (data: Message) => observer.next(data));
      });
  }

  public onEvent(event: Event): Observable<any> {
      return new Observable<Event>(observer => {
          this.socket.on(event, () => observer.next());
      });
  }
}*/